// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i1my","textarea":"styles_textarea__2ZulX"};